module.exports = __webpack_public_path__ + "plus/img/e0f049478ee9c354ba9a0ff67f0c1b8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/person-black.png
// module id = ZPjf
// module chunks = 6